<div class="int-card">
    <mat-card>
        <form autocomplete="off">
            <img (click)="cancel()" class="arrow-left" src="/assets/account/arrow-left.svg" />

            <img class="logo" src="/assets/account/logo_color.png" />
            <div class="card-form">
                <input class="input" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" type="text" [placeholder]="'account.login.user' | translate" maxlength="100" required>
                <div class="input-wrapper">
                    <div class="input-icon">
                        <input class="input" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" [type]="showPassword ? 'text' : 'password'" maxlength="20" [placeholder]="'account.login.password' | translate" required>
                        <mat-icon (click)="showPassword = !showPassword">{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </div>
                    <div class="not-match absolute" *ngIf="errorHint">
                        {{ 'account.login.loginError' | translate }}
                    </div>
                    <div class="not-match absolute" *ngIf="errorHintGeneric">
                        {{ 'account.login.loginErrorGeneric' | translate }}
                    </div>
                    <div class="not-match absolute" *ngIf="errorApprovedHint">
                        {{ 'account.login.loginErrorKyc' | translate }}
                    </div>
                </div>
                <div *ngIf="showCode" class="input-wrapper">
                    <div class="input-icon">
                        <input class="input" [(ngModel)]="code" [ngModelOptions]="{standalone: true}" [type]="'text'" maxlength="6" inputmode="numeric" [placeholder]="'account.login.mfaCode' | translate" required>
                    </div>
                </div>
                <section class="options-login">
                    <mat-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="checked" color="primary">
                        {{ 'account.login.remember' | translate }}
                    </mat-checkbox>
                    <span (click)="forgotPassword()" class="link-gray-dark">
                        {{ 'account.login.forgotPass' | translate }}
                    </span>
                </section>
                <div class="buttons no-margin">
                    <button [disabled]="loading || disableLoginButton()" class="btn default login-button" value="login" type="submit"
                        (click)="login()">
                        {{ 'button.login' | translate }}
                    </button>
                </div>
                <span class="blue">{{ 'account.login.haveAccount' | translate }}
                    <span (click)="createAccount()" class="blue link">{{ 'account.login.signUp' | translate }}</span>
                </span>
            </div>
        </form>
    </mat-card>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
